import React from 'react';
import { Button as MuiButton, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    marginBottom: theme?.spacing(0),
    '& .MuiButton-fullWidth': {
      borderRadius: theme?.spacing(0),
      width: '100%',
    },
    '& .Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
  label: {
    textTransform: 'none',
    fontFamily: 'cernLight',
    fontSize: theme?.spacing(1.75),
  },
  buttonRoot: {
    textTransform: 'none',
    fontFamily: 'cernLight',
    fontSize: theme?.spacing(1.6),
  },
}));

export default function Button(props) {
  const {
    text, size, color, variant, onClick, isProgress,sx, ...other
  } = props;
  const classes = useStyles();

  return (
    <div className={classes?.root}>
      <MuiButton
        variant={variant || 'contained'}
        size={size || 'large'}
        color={color || 'primary'}
        onClick={onClick}
        {...other}
       sx={{
          fontSize: '11px',
          ...sx,
        }}
        classes={{ root: classes?.buttonRoot }}

      >
        {text}
      </MuiButton>
      { isProgress && <div className="progress"><CircularProgress color="inherit" /></div> }
    </div>
  );
}
